import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Modal,TopBar } from '@mui/material';
import { locationActions } from '_actions/location.actions';
import DataTable from '_components/Tables/DataTable';
import ReactCountryFlag from "react-country-flag"
import { instantPricingActions } from '_actions';
import SuiButton from "_softUI/components/SuiButton";
import Grid from '@mui/material/Grid';


export function InstantPricingAddressTable({ open,handleClose, originOrDestiantion }) {

    const dispatch = useDispatch();
   
        useEffect(() => {
            dispatch(locationActions.loadSavedLocations());
        }, [dispatch]);
    
        const locations = useSelector(state => state.location.locations);
        const locationState = useSelector(state => state.location);
    
        const data = useMemo(() => ({
            columns: [
                { Header: "ID", accessor: "id", show: false },
                { Header: "COMPANY", accessor: "name" },
                { Header: "STREET ADDRESS", accessor: "streetAddress" },
                { Header: "CITY", accessor: "city" },
                { Header: "ZIP", accessor: "zip" },
                {
                    Header: "COUNTRY",
                    accessor: "countryAlpha2",
                    Cell: ({ value }) => (
                        <>
                            {value}
                            <ReactCountryFlag svg countryCode={value} height="16" style={{ marginLeft: '10px' }} />
                        </>
                    )
                },
                { Header: "CONTACT", accessor: "contactName" },
            ],
            rows: locations.map(x => ({
                'id': x.id,
                'name': x.name,
                'streetAddress': x.streetAddress,
                'city': x.city,
                'zip': x.zip,
                'countryAlpha2': x.countryAlpha2,
                'contactName': x.contactName
            }))
        }), [locations]);
    
        const handleRowClick = (id) => {
            handleClose()
            const location = locations.find(x=> x.id === id)

            const locData = {
                zip: location.zip,
                country: location.countryAlpha2,
                id: location.id
            }

           dispatch(instantPricingActions.setSearchFromAddressBook(originOrDestiantion,locData))
        }
    


  return (
      <Modal
          open={open}
            onClose={handleClose}
          width='80%'
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >

        

          <Paper >
   
              <DataTable
                  handleRowClick={handleRowClick}
                  canSearch
                  table={data}
                  loading={false}
                  sx={{ maxHeight: 'calc(100% - 120px)' }}


              />
<Grid item container xs={12} justifyContent={'flex-end'} sx={{marginTop:'-4rem'}}>
                                    <SuiButton onClick={handleClose} variant="small" color="secondary" sx={{margin:'0.6rem'}}>
                                        Close
                                    </SuiButton>
                                   
                                </Grid>
          </Paper>
 
      </Modal>
  )
}